export interface MemberPolicies {
  can_create_live?: boolean;
  requires_billing_info?: boolean;
}

interface ConnectionInitiator {
  admin: boolean;
  avatar_url: string;
  created_at: string;
  first_name: string;
  headline: string;
  id: number;
  is_deleted: boolean;
  last_name: string;
  name: string;
  profile_confirmed_at: string;
  public_uid: string;
  sqid: string;
  user_attachable_sgid: string;
  user_id: number;
}

export const ConnectionStatus = {
  PENDING: "pending",
  DETACHED: "detached",
  IGNORED: "ignored",
  WITHDRAWN: "withdrawn",
  ACTIVE: "active",
} as const;

export interface ConnectionToCurrentCommunityMember {
  id: number;
  initiator: ConnectionInitiator;
  recipient: ConnectionInitiator;
  status: (typeof ConnectionStatus)[keyof typeof ConnectionStatus];
}

export interface CommunityMember {
  accepted_or_not_invited?: boolean;
  access_groups?: [];
  admin?: boolean;
  avatar_url?: string;
  connection_to_current_community_member?: ConnectionToCurrentCommunityMember;
  email?: string;
  first_name?: string;
  headline?: string;
  id: number;
  is_admin?: boolean;
  is_deleted?: boolean;
  is_moderator?: boolean;
  last_name?: string;
  messaging_enabled?: boolean;
  name?: string;
  policies?: MemberPolicies;
  profile_confirmed_at?: string | null;
  public_uid?: string;
  roles?: {
    admin: boolean;
    moderator: boolean;
  };
  sqid?: string;
  subscribed_to_marketing_emails?: boolean;
  type?: "CommunityMember";
  user_id?: number;
}
